import React from "react";
import { useSubmitDonateForm } from "../hooks/useSubmitDonateForm";
import { useSelector } from "react-redux";

const Donate = () => {
  const { handleSubmit, isSuccess } = useSubmitDonateForm();

  const singleTypeSlug = "donate";
  const { data } = useSelector((state) => state.cms);
  const cmsData = data[singleTypeSlug] && data[singleTypeSlug].attributes;

  // if (!cmsData) return <LoadingPage/>
  if (isSuccess) return <div>{cmsData.donateMessage}</div>;

  return (
    <form onSubmit={handleSubmit} id="contact-form" name="email-form" data-name="Donate" method="get" className="formcontact">
      <div className="divtextfieldmultiple">
        <div>
          <label htmlFor="name-3">Name </label>
          <input type="text" className="formtextfield w-input" maxLength={256} name="Name" data-name="name" placeholder="Your Name" id="name-3" required={true} />
        </div>
        <div id="w-node-e92e1f8c-cd76-1dda-5059-e7fe5277acf0-95995cb9">
          <label htmlFor="cadetName">Cadet Name (Optional)</label>
          <input type="text" className="formtextfield w-input" maxLength={256} name="Cadet Name" data-name="cadetName" placeholder="Cadet Name" id="cadetName" required="" />
        </div>
      </div>
      <div className="divtextfieldmultiple">
        <div id="w-node-e92e1f8c-cd76-1dda-5059-e7fe5277acf5-95995cb9">
          <label htmlFor="contact-email">Email</label>
          <input type="email" className="formtextfield w-input" maxLength={256} name="Email" data-name="email" placeholder="Your Email" id="contact-email" required={true} />
        </div>
        <div id="w-node-e92e1f8c-cd76-1dda-5059-e7fe5277acf9-95995cb9">
          <label htmlFor="contact-phone">Telephone</label>
          <input type="tel" className="formtextfield w-input" maxLength={256} name="Phone" data-name="phone" placeholder="Your Telephone " id="contact-phone" required={true} />
        </div>
      </div>
      <div>
        <label htmlFor="amount-pledged">Amount Pledged</label>
        <input
          type="number"
          step="any"
          className="formtextfield w-input"
          maxLength={256}
          name="Amount Pledged"
          data-name="amount pledged"
          min={0}
          placeholder="$ 0"
          id="amount-pledged"
          required={true}
        />
      </div>
      <div>
        <label for="Donate-Message">Message (Optional)</label>
        <textarea placeholder="Message" maxlength="5000" id="Donate-Message" name="Message" data-name="field" class="formtextfield w-input"></textarea>
      </div>

      <label className="w-checkbox">
        <input type="checkbox" id="checkbox" name="Receipt" data-name="Checkbox" required="" className="w-checkbox-input" />
        <span className="checkbox-label w-form-label" htmlFor="checkbox">
          Copy of Receipt?
        </span>
      </label>
      <div className="divalignmentright">
        <input type="submit" data-wait="Please wait..." defaultValue="Submit" className="buttonsubmit w-button" />
      </div>
    </form>
  );
};

export default Donate;
